import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fr/projets')({
  component: Outlet,
})
